import { render } from "./ChecklistsInformations.vue?vue&type=template&id=edd30050&scoped=true"
import script from "./ChecklistsInformations.vue?vue&type=script&lang=js"
export * from "./ChecklistsInformations.vue?vue&type=script&lang=js"

import "./ChecklistsInformations.vue?vue&type=style&index=0&id=edd30050&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edd30050"]])

export default __exports__